import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
}

const GridPresetOneThird = ({ children }: GridRowProps) => (
  <GridCell spanColsDesktop={4} spanColsTablet={6} spanColsMobile={6}>
    {children}
  </GridCell>
);

export default GridPresetOneThird;
